import { Box, Icons, useTheme } from '@ublend-npm/aulaui-core';
import React from 'react';
import { createStyles } from './LinkedMaterials.styles';

interface LinkedMaterialsProps {
  containerSx?: any;
  title: string | null;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  remainingMaterialCount: number;
}

const LinkedMaterials = ({
  containerSx,
  title,
  onClick,
  onKeyDown,
  remainingMaterialCount = 0,
}: LinkedMaterialsProps) => {
  if (!title) return null;
  const theme = useTheme();
  const styles = createStyles(theme as any);

  return (
    <Box
      sx={containerSx ? containerSx : styles.linkedMaterialTab}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={onKeyDown}
      aria-label={`Linked material: ${title}`}
    >
      <Icons.BookOutlined sx={styles.icon} aria-hidden="true" />
      <Box sx={styles.title}>{title}</Box>
      {remainingMaterialCount > 0 && (
        <Box sx={styles.count}>+ {remainingMaterialCount}</Box>
      )}
    </Box>
  );
};

export default LinkedMaterials;
